//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxPay from '@/common/js/wxPay.js'
export default {
  mixins: [wxPay],
  components: {
  },
  name: 'paymentSelect',
  data() {
    return {
      loading: false,
      paymentSelection: [
        { name: '微信支付', payType: 'WECHAT_PAY', icon: '/static/public/wxIcon.png' },
        // { name: '农行支付', payType: 'ABCBANK_PAY' }
      ],
      selected: '',
      price: 0.01,
      creatTime: '',
      leftTime: '00:00',
      weixinBridgeInfo: {},
      hasCode: 1,
      payType: 'WECHAT_PAY'
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  watch: {
    'orderId'(val) {
      if (val) {
        this.init()
      }
    }
  },
  mounted() {
    // this.heights = window.screen.height
  },
  methods: {
    init() {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/personalCenter/order/queryDetail',
        data: {
          orderCode: this.orderId
        }
      }).then(result => {
        let orderInfo = result.data.orderInfoDetailVo
        this.price = orderInfo.payPrice || 0.01
        this.creatTime = orderInfo.orderTime
        if (orderInfo.orderStatus === 10) {
          this.getLeftTime()
        } else {
          uni.showToast({
            title: '该订单不是待支付订单',
            icon: 'none'
          })
          this.$emit('on-close')
        }
        this.loading = false
      }).catch(result => {
        this.loading = false
      })
    },
    timeout() {
      if (this.leftTime === '00:00') {
        uni.showToast({
          title: '该订单已关闭',
          icon: 'none'
        })
        this.$emit('on-close')
      }
    },
    handleSelect() {
      // console.log(this.selected)
    },
    radioChange(evt) {
      this.selected = evt.target.value;
      // for (let i = 0; i < this.paymentSelection.length; i++) {
      //   if (this.paymentSelection[i].payType === evt.target.value) {
      //     this.selected = this.paymentSelection[i].payType;
      //     break;
      //   }
      // }
    },
    handlePay() {
      if (this.selected === '') {
        uni.showToast({
          title: '请选择支付方式',
          icon: 'none'
        })
      } else if (!this.orderId) {
        uni.showToast({
          title: '请检查订单号是否真实有效',
          icon: 'none'
        })
      } else {
        this.payType = this.selected







        this.wxminiPayOrder(this.orderId)

      }
    }

  }
}
